import { useEffect, useRef, useState } from "react";
import ReactImageLightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import Axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import { useSelector } from "react-redux";

import { URL_LIST_ALL } from "../configs/api";
import PostAction from "./PostAction";
import EditPostModal from "./EditPostModal";
import PostsComment from "./PostsComment";
import { checkRole } from "../model";
import PostHeader from "./PostHeader";


const getImageLayoutClass = (count) => {
  if (count === 1) return "single";
  if (count === 2) return "two";
  if (count === 3) return "three";
  if (count === 4) return "four";
  return count >= 5 ? "five" : "";
};

const PostItem = ({ post, viewmore, listGroup, onShowPost, onPinPost }) => {
  const { user } = useSelector((state) => state.auth);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [myVote, setMyVote] = useState([]);
  const [countComment, setCountComment] = useState(0);
  const [showAction, setShowAction] = useState(false);

  const linkify = (html) =>
    html.replace(
      /(?<!src="|href="|">)(https?:\/\/[^\s<]+)/g,
      '<a href="$1" class="text-danger" target="_blank" rel="noopener noreferrer">$1</a>'
    );

  useEffect(() => {
    if (post?.post_vote?.length > 0 && user?.data?.id) {
      const myVoteEntry = post.post_vote.find((v) => v.user_id === user.data.id);
      if (Array.isArray(myVoteEntry?.vote)) setMyVote(myVoteEntry.vote);
    }
  }, [post, user]);

  const updateVote = async (votes) => {
    try {
      const { data } = await Axios.post(`${URL_LIST_ALL}post_vote`, { user_id: user.data.id, post_id: post.id, vote: votes }, user.config);
      if (data.status !== "success") {
        confirmAlert({ title: "Lỗi", message: data.message, buttons: [{ label: "OK" }] });
      }
    } catch (err) {
      console.error(err);
    }
  };

  const actionVote = (index) => {
    if (post.post_type === "single_vote") {
      const newVote = myVote.includes(index) ? [] : [index];
      setMyVote(newVote);
      updateVote(newVote);
    } else if (post.post_type === "multiple_vote") {
      const newVote = myVote.includes(index) ? myVote.filter((v) => v !== index) : [...myVote, index];
      setMyVote(newVote);
      updateVote(newVote);
    }
  };

  const getVotersByAnswerIndex = (index) =>
    post.post_vote?.filter((v) => Array.isArray(v.vote) && v.vote.includes(index)) || [];

  return (
    <div className="w-100 post-item-insite">
      <div className="w-100 poster-info d-flex">
        <PostHeader data={post} />
        {(user.data.id === post.user_id || checkRole(user, 'deletepost', '') || checkRole(user, 'pinpost', '')) && (
          <div className="more-action">
            <button type="button" className="btn btn-sm btn-outline-primary btn-more" onClick={()=>setShowAction(!showAction)}>
              <span className="fas fa-ellipsis-v"></span>
            </button>
            <div className={"action-group " + (showAction ? "d-block" : "d-none")}>
              {(user.data.id == post.user_id || user.data.id == 1) &&
                <button className="btn btn-sm btn-outline-primary me-2" title="Sửa bài viết" onClick={() => setShowEditModal(true)}>
                  <i className="fas fa-pencil-alt"></i> Sửa bài viết
                </button>
              }
              {(checkRole(user, 'deletepost', '') || user.data.id === post.user_id) &&
                <button className="btn btn-sm " title="Xóa bài viết" onClick={() => confirmAlert({ title: "Cảnh báo", message: "Bạn có chắc chắn xóa bài viết này?", buttons: [{ label: "OK", onClick: () => Axios.put(`${URL_LIST_ALL}posts/${post.id}`, { status: 2 }, user.config) }] })}>
                  <i className="fas fa-trash-alt"></i> Xóa bài viết
                </button>
              }
              {checkRole(user, 'pinpost', '') &&
                <button className={"btn btn-sm "} disabled={post.pin ? true : false} title="Ghim bài viết"
                  onClick={() => {
                    confirmAlert({
                      title: "Cảnh báo",
                      message: "Bạn có chắc chắn ghim bài viết này?",
                      buttons: [{
                        label: "OK",
                        onClick: () => {
                          Axios.put(`${URL_LIST_ALL}posts/${post.id}`, { pin: 1 }, user.config).then((res) => {
                            if (res.data.status === "success") {
                              if (typeof onPinPost === 'function') {
                                onPinPost(post.id); // 🟢 Cập nhật danh sách
                              }
                            } else {
                              alert(res.data.message);
                            }
                          }).catch(console.log);
                        }
                      }]
                    });
                  }}
                >
                  {post.pin ? "Đã ghim" : "Ghim bài"}
                </button>
              }
              <button type="button" className="btn btn-sm" title="Lấy link chia sẻ" onClick={() => {
                navigator.clipboard.writeText("https://noibo.bhsgroup.vn/bang-tin/" + post.id)
                  .then(() => {
                    alert("Đã sao chép link chia sẻ!");
                  })
                  .catch((err) => {
                    console.error("Lỗi khi sao chép: ", err);
                  });
              }}>
                <span className="fas fa-link"></span> Copy link
              </button>
            </div>
          </div>
        )}
      </div>

      <div className="w-100 mt-2 post-content" dangerouslySetInnerHTML={{ __html: linkify(post.post_content) }} />

      {post.list_images?.length > 0 && (
        <div className={`post-images ${getImageLayoutClass(post.list_images.length)}`}>
          {post.list_images.map((img, index) => (
            <img
              key={index}
              src={img}
              alt={`img-${index}`}
              className={`img-${index}`}
              style={{ cursor: "pointer" }}
              onClick={() => {
                setPhotoIndex(index);
                setIsOpen(true);
              }}
            />
          ))}
        </div>
      )}

      {["single_vote", "multiple_vote"].includes(post.post_type) && Array.isArray(post.post_meta) && post.post_meta?.length > 0 && (
        <div className="w-100 list-vote">
          <div className="row">
            {post.post_meta.map((answer, index) => {
              const answerIndex = index + 1;
              const voters = getVotersByAnswerIndex(answerIndex);
              return (
                <div className="col-12 col-sm-6 mt-2 vote-item" key={index}>
                  <button
                    type="button"
                    className={`w-100 btn btn-sm border text-left btn-vote ${myVote.includes(answerIndex) ? "btn-success" : ""}`}
                    onClick={() => actionVote(answerIndex)}
                  >
                    {answerIndex}. {answer}
                  </button>
                  {voters.length > 0 && (
                    <div className="vote-info position-absolute text-muted small">
                      <span className="counter">+{voters.length}</span>
                      {!post.vote_private && (
                        <div className="list-info shadow-sm border rounded">
                          {voters.map((v, i) => (
                            <div className="info-item" key={i}>
                              <strong>{v.fullname}</strong> | {v.part_name} | {v.company_name}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}

      <div className="reaction">
        <PostAction post={post} userReact={post.youlike} onShowPost={onShowPost} countComment={countComment} />
      </div>

      <div style={{ marginTop: 10 }}>
        {post.getComment && <PostsComment post={post} initialComments={post.getComment} viewmore={viewmore} onCommentChange={(newList) => setCountComment(newList.filter((c) => c.status === 1).length)} />}
      </div>

      {showEditModal && <EditPostModal post={post} listGroup={listGroup} onClose={() => setShowEditModal(false)} onUpdated={() => { }} />}

      {isOpen && (
        <ReactImageLightbox
          mainSrc={post.list_images[photoIndex]}
          nextSrc={post.list_images[(photoIndex + 1) % post.list_images.length]}
          prevSrc={post.list_images[(photoIndex + post.list_images.length - 1) % post.list_images.length]}
          onCloseRequest={() => setIsOpen(false)}
          onMovePrevRequest={() => setPhotoIndex((photoIndex + post.list_images.length - 1) % post.list_images.length)}
          onMoveNextRequest={() => setPhotoIndex((photoIndex + 1) % post.list_images.length)}
        />
      )}
    </div>
  );
};

export default PostItem;
